import React from "react";

const stylequestheight = {
        height: "70px",
        marginBottom: "50px",
        marginLeft:"25px",
        marginRight:"40px",
    }
const styletestline = {
         height: "2px",
        width: "77%",
        padding: "0",
        marginTop: "35px",
        marginLeft: "50px"
}
const styletestimonials = {
    height: "70px",
    width: "fit-content",

}
export default function Testimonial() {
    return (
        <>
            <div id="testimonials_"></div>
            <div id='linetop' id="testimonials"></div>
        <div id='bankruptcy' >
            <div className="row" style={stylequestheight}>
                <div className="column-2 " id='bankruptcytitle' style={styletestimonials}>Отзывы</div>
                <div className="column-2" id="line" style={styletestline}></div>
            </div>
            <div className="question">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2  text-center">
                            <div><img className="testpic" src="../images/circle1.png" /></div>
                            <div className="testname">Алексей Милюков</div>
                        </div>
                        <div className="col-sm">
                            <div className="testtext">Современные технологии достигли такого уровня, что высококачественный прототип будущего проекта создаёт необходимость включения в производственный план целого ряда внеочередных мероприятий с учётом комплекса новых принципов формирования материально-технической и кадровой базы. Но высококачественный прототип будущего проекта однозначно фиксирует необходимость как самодостаточных, так и внешне зависимых концептуальных решений. Высокий уровень вовлечения представителей целевой аудитории является четким доказательством <a href="#">простого факта: ....</a></div>
                        </div>
                    </div>
                </div>
            </div>
             <div className="question">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2  text-center">
                            <div><img className="testpic" src="../images/circle2.png" /></div>
                            <div className="testname">Алексей Милюков</div>
                        </div>
                        <div className="col-sm">
                            <div className="testtext">Современные технологии достигли такого уровня, что высококачественный прототип будущего проекта создаёт необходимость включения в производственный план целого ряда внеочередных мероприятий с учётом комплекса новых принципов формирования материально-технической и кадровой базы. Но высококачественный прототип будущего проекта однозначно фиксирует необходимость как самодостаточных, так и внешне зависимых концептуальных решений. Высокий уровень вовлечения представителей целевой аудитории является четким доказательством <a href="#">простого факта: ....</a></div>
                        </div>
                    </div>
                </div>
            </div>
             <div className="question">
                 <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2 text-center">
                            <div><img className="testpic" src="../images/circle3.png" /></div>
                            <div className="testname">Алексей Милюков</div>
                        </div>
                        <div className="col-sm">
                            <div className="testtext">
                                Современные технологии достигли такого уровня, что высококачественный прототип будущего проекта создаёт необходимость включения в производственный план целого ряда внеочередных мероприятий с учётом комплекса новых принципов формирования материально-технической и кадровой базы. Но высококачественный прототип будущего проекта однозначно фиксирует необходимость как самодостаточных, так и внешне зависимых концептуальных решений. Высокий уровень вовлечения представителей целевой аудитории является четким доказательством <a href="#">простого факта: ....</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           <div class="text-center" id="testbtn">
                <button id="alldealbtn">Все отзывы</button>
        </div> 
        </div>
            </>
    )
}